<template>
  <div
    class="w-full mx-auto text-white p-4 lg:p-16 flex flex-col lg:flex-row gap-12 sm:gap-16 lg:gap-24 bg-no-repeat bg-cover bg-center"
    :style="{ backgroundImage: `url(${downloadbg})` }"
  >
    <!-- Left Section -->
    <div class="flex-1 space-y-6 lg:space-y-8">
      <h1
        class="text-[24px] md:text-[32px] lg:text-[36px] font-semibold leading-snug sm:leading-tight lg:leading-snug"
      >
        {{ getLocalized(contentData, "title") }}
      </h1>

      <p class="text-[16px] lg:text-[24px] leading-relaxed max-w-lg">
        {{ getLocalized(contentData, "description") }}
      </p>

      <!-- Download Buttons -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mt-8">
        <!-- Google Play Button -->
        <a
          href="#"
          onclick="event.preventDefault()"
          class="flex items-center gap-4 bg-white rounded-lg p-4 hover:bg-gray-100 transition-all duration-300 ease-in-out"
        >
          <img
            :src="playstore"
            alt="Google Play"
            class="h-5 w-5 md:w-10 md:h-10"
          />
          <div>
            <p class="text-sm md:text-base text-gray-600">Download On</p>
            <p class="text-sm md:text-2xl font-semibold text-black">
              Google Play
            </p>
          </div>
        </a>

        <!-- App Store Button -->
        <a
          href="#"
          onclick="event.preventDefault()"
          class="flex items-center gap-4 bg-white rounded-lg p-4 hover:bg-gray-100 transition-all duration-300 ease-in-out"
        >
          <img
            :src="apple"
            width
            alt="App Store"
            class="h-5 w-5 md:w-10 md:h-10"
          />
          <div>
            <p class="text-sm md:text-base text-gray-600">Download On</p>
            <p class="text-sm md:text-2xl font-semibold text-black">
              App Store
            </p>
          </div>
        </a>
      </div>
    </div>

    <!-- Right Section -->
    <div class="flex-1 md:flex items-center justify-center hidden">
      <img
        :src="main"
        alt="App Screenshot"
        class="md:max-w-full h-auto object-contain"
      />
    </div>
  </div>
</template>

<script>
import main from "@/assets/pictures/mobileDownload.svg";
import downloadbg from "@/assets/pictures/download-bg.png";
import { useLocalization } from "@/composable/useLocalization";
import { fetchContentSection } from "@/composable/apiService";
import appleApp from "@/assets/pictures/appleApp.png";
import playstore from "@/assets/pictures/playstore.png";

export default {
  data() {
    return {
      apple: appleApp,
      playstore: playstore,
      downloadbg: downloadbg,
      main: main,
      contentData: {},
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  methods: {
    async fetchContent() {
      this.contentData = await fetchContentSection(4);
    },
  },
  mounted() {
    this.fetchContent();
  },

  computed: {
    // Method to get the localized text based on the current language

    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
};
</script>

<style scoped>
/* Optional: Custom styles to improve the responsiveness further, like handling image loading */
</style>
